/**
 * Created by Florin David on 11/10/2016.
 */
import React, {
  ReactNode,
  CSSProperties,
  ChangeEvent,
  KeyboardEvent,
  MouseEvent,
  TouchEvent,
  FocusEvent,
  SyntheticEvent,
  MouseEventHandler,
  ReactElement,
  ComponentClass,
  ClassAttributes,
  isValidElement,
} from 'react'

import {
  FormattedMessage,
  MessageDescriptor,
  FormattedNumber,
} from 'react-intl'

interface FormattedMessageProps extends MessageDescriptor {
  values?: Record<string, string | number | boolean | ReactElement>
  id?: string
}

/**
 * HOC FormattedMessage
 * - add `????` if missing id
 */
const CustomFormattedMessage = (props: FormattedMessageProps): ReactElement => {
  const { id, ...rest } = props
  return <FormattedMessage id={id || '????'} {...rest} />
}

export {
  React,
  isValidElement,
  CustomFormattedMessage as FormattedMessage,
  FormattedNumber,
}

export type {
  ReactNode,
  ReactElement,
  ComponentClass,
  ClassAttributes,
  CSSProperties,
  ChangeEvent,
  KeyboardEvent,
  MouseEvent,
  FocusEvent,
  SyntheticEvent,
  TouchEvent,
  MouseEventHandler,
}

export default React
